import AdminUsersPanel from "../components/AdminUsersPanel";

/**
 * `/admin/users` — the Users section of the one admin area (issue #226;
 * Andreas's 2026-08-20 decision on the iteration plan: "one /admin area
 * with sections", Guides and Users, not two destinations).
 *
 *   /admin
 *   ├── Guides   <- AdminGuides.jsx (#219)
 *   └── Users    <- here
 *
 * Slice 2 landed the provisioning panel on the ADMIN DASHBOARD, because at
 * the time `/admin` did not exist and the dashboard was the only place an
 * admin could reach. This page is where it belongs, and moving it is the
 * whole point: an admin signing in now has one door (`nav-admin`) to every
 * admin-only surface, instead of accounts on the dashboard and guides
 * behind a URL.
 *
 * Deliberately thin — the same shape `AdminGuides.jsx` has: a section
 * header naming where you are, and the panel that does the work.
 * `AdminUsersPanel.jsx` owns its own fetching, state and the one-time
 * credential, so nothing about the move changed how provisioning behaves;
 * the component is rendered here instead of there and is otherwise
 * untouched by the relocation.
 */
export default function AdminUsers() {
  return (
    <div className="space-y-6" data-testid="admin-users-page">
      <div>
        <p className="text-[11px] uppercase tracking-[0.2em] text-slate-500">Admin · Users</p>
        <h1 className="font-display font-black text-2xl text-slate-900 mt-1">Accounts</h1>
        <p className="text-slate-500 text-sm mt-1">
          Create player and coach accounts, re-issue a password for someone who's lost theirs, and
          give an account a second role — a player who also coaches, or a coach who also plays.
        </p>
      </div>

      <AdminUsersPanel />
    </div>
  );
}
